"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "purposes", {
    enumerable: true,
    get: function() {
        return purposes;
    }
});
var purposes = {
    "acquisitio-HTC3G8Nt": {
        category: "user_consent_acquisition",
        default_value: false,
        short_name: "acquisition"
    },
    "analytics-2jU84YGe": {
        category: "user_consent_analytics",
        default_value: false,
        short_name: "analytics"
    },
    "functional-2c7amHYy": {
        category: "user_consent_functionality",
        default_value: false,
        short_name: "functionality"
    },
    "technical-Aq8qfL3F": {
        category: "user_consent_technical",
        default_value: true,
        short_name: "technical"
    }
};

//# sourceMappingURL=purposes.js.map